// Facts the Privacy Policy and Terms of Service rely on, in one place so they
// stay in step with each other. Have a lawyer review both pages before relying
// on them, and update EFFECTIVE_DATE whenever the wording changes.
export const LEGAL = {
    company: 'Tantalum Technology Corp.',
    product: 'light speed',
    site: 'light-speed-ai.com',
    siteUrl: 'https://light-speed-ai.com',
    // Must be a mailbox someone reads: privacy requests have legal deadlines
    email: 'hello@light-speed-ai.com',
    effectiveDate: 'October 1, 2026',
};
